var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import styles from './SecondaryButton.module.scss';
import { Button } from 'antd';
export var SecondaryButton = function (_a) {
    var title = _a.title, handleClick = _a.handleClick, _b = _a.isActive, isActive = _b === void 0 ? false : _b, _c = _a.size, size = _c === void 0 ? 'middle' : _c, _d = _a.style, style = _d === void 0 ? {} : _d, isDisabled = _a.isDisabled, _e = _a.isBordered, isBordered = _e === void 0 ? true : _e, children = _a.children, _f = _a.fontSize, fontSize = _f === void 0 ? '' : _f;
    var className = isDisabled ? styles.disabledBtn : isActive ? styles.active : styles.defaultClass;
    return (_jsx(Button, __assign({ type: 'text', onClick: handleClick, className: className, size: size, style: __assign(__assign({}, style), { borderRadius: isBordered ? '2px' : 0, fontSize: fontSize ? fontSize : 'min(0.75vw, 14px)' }), disabled: isDisabled }, { children: title ? title : children })));
};
